import api from '../../utils/api'

import { useEffect, useState } from 'react'




/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormAdditive from './Form/FormAdditive'

function EditAdditive({id , btCancelAction, handleOnSuccess}){
    const [additive, setAdditive] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const {setFlashMessage} = useFlashMessage()

    useEffect(() => {

        api.get(`/additive/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            setAdditive(response.data.additive)
        })
    }, [token, id])

    async function updateAdditive(additive) {
        let msgType = 'success'


        const data = await api.patch(`additive/update/${additive._id}`, additive, {
            headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
        },
        }).then((response) => {

            return response.data
        }).catch((err) => {

            msgType= 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error'){
            handleOnSuccess()
            }

    }


    return (
        additive.name && (
            <FormAdditive title="Editar Aditivo" handleSubmit={updateAdditive} btnText="Salvar" btCancelAction={btCancelAction} additiveData={additive} />
        )
    )
}

export default EditAdditive
